import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from './store'
import ElementUI from 'element-ui';
import './permission' // permission control
import './utils/permission.js'
import 'element-ui/lib/theme-chalk/index.css';
import cusHeader from '@/components/cus-header/cus-header' //主框架
import language from './utils/lang/zn.js'
Vue.prototype.$language = language
import {
	getLanguageConfig,
} from '@/common/api/public.js'
let setLanguage = async () => {
	const {
		data
	} = await getLanguageConfig()
	if (data.switch) {
		Vue.prototype.$language = data[data.switch]
	} else {
		Vue.prototype.$language = data.zh
	}
	document.title = Vue.prototype.$language.systemTitle.name
	let getCreate = function(url) {
		var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
		link.type = 'image/x-icon';
		link.rel = 'shortcut icon';
		link.href = url
		document.getElementsByTagName('head')[0].appendChild(link);
	}
	if (Vue.prototype.$language.systemIco.name) {
		getCreate(Vue.prototype.$language.systemIco.name)
	}
}
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.component('cus-header', cusHeader)
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
// setLanguage()
// console.log(language)